import { render, staticRenderFns } from "./TableInvoiceGeneral.vue?vue&type=template&id=7d72d4b6&scoped=true"
import script from "./TableInvoiceGeneral.vue?vue&type=script&lang=js"
export * from "./TableInvoiceGeneral.vue?vue&type=script&lang=js"
import style0 from "./TableInvoiceGeneral.vue?vue&type=style&index=0&id=7d72d4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d72d4b6",
  null
  
)

export default component.exports